import React, { Component } from 'react'
import { MDBContainer, MDBRow, MDBCol, MDBBtn, MDBIcon, MDBInput, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter } from 'mdbreact';
import { MDBNavbar, MDBNavbarBrand, MDBNavbarNav, MDBNavbarToggler, MDBCollapse, MDBNavItem, MDBNavLink, MDBMask, MDBView, MDBJumbotron, MDBBox,   MDBCardFooter } from 'mdbreact';
import { Form, Input, Button, Checkbox, message } from 'antd';

import Axios from 'axios'
import { URL } from '../api';
import logo from './img/logokpru.png'
import FadeIn from 'react-fade-in';
import p1 from './img/1656587759_2-illustration_png.png'
import p2 from './img/1656587759_4-illustration_png.png'
import p3 from './img/1656587761_12-illustration_png.png'
import p4 from './img/1656587766_35-illustration_png.png'
import p5 from './img/1656587769_55-illustration_png.png'
import p6 from './img/1656587765_31-illustration_png.png'

import { HorizontalBar } from 'react-chartjs-2';


import Swal from 'sweetalert2'
import {
  MDBTypography,
  MDBCard,
  MDBCardBody,
  MDBCardImage,
  MDBCardTitle,
  MDBCardText
} from 'mdbreact';


export default class Home extends Component {


  constructor(props) {
    super(props);
    this.state = {
      value: '',
      Psaaword: '',
      modal: false,
      collapse: false,
      isWideEnough: false,

    };
    this.handleChange = this.handleChange.bind(this);
    this.handleChange2 = this.handleChange2.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.toggle = this.toggle.bind(this);
    this.onClick = this.onClick.bind(this);
  }

  onClick() {
    this.setState({
      collapse: !this.state.collapse,
    });
  }

  toggle = () => {
    this.setState({
      modal: !this.state.modal
    });
  }

  handleChange(event) { this.setState({ value: event.target.value }); }
  handleChange2(event) { this.setState({ Psaaword: event.target.value }); }

  handleSubmit(event) {
    // alert('A name was submitted: ' + this.state.value);
    event.preventDefault();

    const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
    datafrm.append("txtemail", this.state.value);
    datafrm.append("txtpass", this.state.Psaaword);


    const user = {
      "txtemail": this.state.value,
      "txtpass": this.state.Psaaword
    };

    fetch('https://mua.kpru.ac.th/FrontEnd_Mis/login/login/', {
      method: 'POST',
      body: JSON.stringify(user),
      headers: {

      }
    })
      .then(res => res.json())
      .then((res) => {
        console.log(res);
        if (res[0].loginstatus === "1") {


          //  alert("เข้าสู่ระบบสำเร็จ")

          localStorage.setItem('name', res[0].frist_name + "  " + res[0].last_name);

          message.success("เข้าสู่ระบบสำเร็จ")
          localStorage.setItem('loginstatus', res[0].loginstatus);
          localStorage.setItem('type2', res[0].employee_id);
          localStorage.setItem('admin_type', 2);

          window.location.href = '/vaccinekpru/Stuall'
        } else {


          Swal.fire(
            'ไม่สามารถเข้าถึงระบบได้',
            'กรุณาลองอีกครั้ง',
            'question'
          )

        }

      })
      .catch(err => {
        console.log('request failed', err);
      })
  }


  update = () => {
    this.setState({
      name: "",
      lname: ""
    })
  }


  render() {

    const dataHorizontal = {
      labels: ['Red', 'Orange', 'Yellow', 'Green', 'Blue', 'Purple', 'Grey'],
      datasets: [
        {
          label: 'My First Dataset',
          data: [22, 33, 55, 12, 86, 23, 14],
          fill: false,
          backgroundColor: [
            'rgba(255, 99, 132, 0.2)',
            'rgba(255, 159, 64, 0.2)',
            'rgba(255, 205, 86, 0.2)',
            'rgba(75, 192, 192, 0.2)',
            'rgba(54, 162, 235, 0.2)',
            'rgba(153, 102, 255, 0.2)',
            'rgba(201, 203, 207, 0.2)'
          ],
          borderColor: [
            'rgb(255, 99, 132)',
            'rgb(255, 159, 64)',
            'rgb(255, 205, 86)',
            'rgb(75, 192, 192)',
            'rgb(54, 162, 235)',
            'rgb(153, 102, 255)',
            'rgb(201, 203, 207)'
          ],
          borderWidth: 1
        }
      ]
    }

    return (

      <MDBContainer >
        <MDBRow bgcolor="warning-color-dark ">

        </MDBRow>
        <MDBRow >
          <MDBCol md="12">
            <div>
              {/* <img src="https://research.kpru.ac.th/culture/LogoRDI.png" className="rounded mx-auto d-block w-50" alt="aligment" /><br/> */}
              {/* <img src={logo} className="rounded mx-auto d-block w-10 " alt="aligment" /><br/> */}

              <FadeIn>
              <MDBJumbotron className="p-4" fluid >
                <MDBTypography blockquote bqColor='primary' className='h-0'>

                  <MDBIcon icon="user-injured" />   ด้านรับสมัครนักศึกษา
                </MDBTypography>
                {/* <MDBTypography note noteColor='primary' noteTitle='ด้านนักศึกษา '> </MDBTypography> */}

                <div className='d-flex justify-content-center'>
                  <MDBRow  >
                  <MDBCol lg="3" md="12" className="mb-4">
                  <a href='/Studentreport'>
                        <MDBCard >
                          <MDBCardImage className="img-fluid" src={p1}
                            waves />
                             <MDBCardFooter color="orange darken-2"> <p className='text-center'>จำนวนผู้สมัคร</p></MDBCardFooter>
                        </MDBCard>
                      </a>  
                  </MDBCol>
                  <MDBCol lg="3" md="12" className="mb-4">
                  <a href='/Studentschoolreportconfirm'>
                        <MDBCard>
                          <MDBCardImage className="img-fluid" src={p2}
                            waves />
                           <MDBCardFooter color="orange darken-2"> <p className='text-center'>จำนวนผู้รายงานตัว</p></MDBCardFooter>
                        </MDBCard>
                        </a> 
                  </MDBCol>
                  {/* <MDBCol lg="3" md="12" className="mb-4">
                  <a href='/Studentschoolreportconfirm'>
                        <MDBCard>
                          <MDBCardImage className="img-fluid" src={p2}
                            waves />
                           <MDBCardFooter color="orange darken-2"> <p className='text-center'>จำนวนผู้รายงานตัว</p></MDBCardFooter>
                        </MDBCard>
                        </a> 
                  </MDBCol> */}
           
                  </MDBRow>
                  </div>
          
              </MDBJumbotron>



              <MDBJumbotron className="p-4" fluid >
                <MDBTypography blockquote bqColor='warning' className='h-0'>
                  {/* <MDBBox tag='p' mb={0} className='bq-title'>
                                     นักศึกษา
                                    </MDBBox> */}
                  <MDBIcon icon="user-injured" />   ด้านนักศึกษา
                </MDBTypography>

                <div className='d-flex justify-content-center'>
                  <MDBRow  >
                  <MDBCol lg="3" md="12" className="mb-4">
                  <a href='/Studentkpru'>
                      <MDBCard>
                        <MDBCardImage className="img-fluid" src={p4}
                          waves />
                        <MDBCardFooter color="orange darken-2">  <p className='text-center'>จำนวนนักศึกษา</p></MDBCardFooter>
                      </MDBCard>
                      </a> 
                  </MDBCol>
                  <MDBCol lg="3" md="12" className="mb-4">
                  <a href='/StudentDropout'>
                        <MDBCard >
                          <MDBCardImage className="img-fluid" src={p3}
                            waves />
                             <MDBCardFooter color="orange darken-2"> <p className='text-center'>จำนวนออกการคัน</p></MDBCardFooter>
                          
                        </MDBCard>
                      </a>  
                  </MDBCol>
                
                  </MDBRow>

                </div>
                {/* <HorizontalBar
                              data={dataHorizontal}
                              options={{ responsive: true }}
                            /> */}
              </MDBJumbotron>


              <MDBJumbotron className="p-4" fluid >
                <MDBTypography blockquote bqColor='warning' className='h-0'>
                  {/* <MDBBox tag='p' mb={0} className='bq-title'>
                                     นักศึกษา
                                    </MDBBox> */}
                  <MDBIcon icon="user-injured" />   ด้านผู้สำเร็จการศึกษา
                </MDBTypography>

                <div className='d-flex justify-content-center'>
                  <MDBRow  >
                  <MDBCol lg="3" md="12" className="mb-4">
                  <a href='/Studentfinish'>
                        <MDBCard>
                          <MDBCardImage className="img-fluid" src={p5}
                            waves />
                           <MDBCardFooter color="orange darken-2"> <p className='text-center'>จำนวนผู้สำเร็จการศึกษา</p></MDBCardFooter>
                        </MDBCard>
                        </a> 
                  </MDBCol>
                  </MDBRow>

                </div>
                {/* <HorizontalBar
                              data={dataHorizontal}
                              options={{ responsive: true }}
                            /> */}
              </MDBJumbotron>

              <MDBJumbotron className="p-4" fluid >
                <MDBTypography blockquote bqColor='warning' className='h-0'>
                  {/* <MDBBox tag='p' mb={0} className='bq-title'>
                                     นักศึกษา
                                    </MDBBox> */}
                  <MDBIcon icon="user-injured" />   ด้านหลักสูตร
                </MDBTypography>

                <div className='d-flex justify-content-center'>
                  <MDBRow  >
                  <MDBCol lg="3" md="12" className="mb-4">
                  <a href='/Studentcurr'>
                        <MDBCard>
                          <MDBCardImage className="img-fluid" src={p5}
                            waves />
                           <MDBCardFooter color="orange darken-2"> <p className='text-center'>จำนวนหลักสูตร</p></MDBCardFooter>
                        </MDBCard>
                        </a> 
                  </MDBCol>
                  </MDBRow>

                </div>
                {/* <HorizontalBar
                              data={dataHorizontal}
                              options={{ responsive: true }}
                            /> */}
              </MDBJumbotron>

              <MDBJumbotron className="p-4" fluid >
                <MDBTypography blockquote bqColor='warning' className='h-0'>
                  {/* <MDBBox tag='p' mb={0} className='bq-title'>
                                     นักศึกษา
                                    </MDBBox> */}
                  <MDBIcon icon="user-injured" />   ด้านอื่นๆ
                </MDBTypography>

                <div className='d-flex justify-content-center'>
                  <MDBRow  >
                  <MDBCol lg="3" md="12" className="mb-4">
                  <a href='/Studentschoolmis'>
                        <MDBCard>
                          <MDBCardImage className="img-fluid" src={p5}
                            waves />
                           <MDBCardFooter color="orange darken-2"> <p className='text-center'>จำนวนนักเรียนมัธยม</p></MDBCardFooter>
                        </MDBCard>
                        </a> 
                  </MDBCol>
                  </MDBRow>

                </div>
                {/* <HorizontalBar
                              data={dataHorizontal}
                              options={{ responsive: true }}
                            /> */}
              </MDBJumbotron>

              </FadeIn>




            </div>
          </MDBCol>

        </MDBRow>



      </MDBContainer>


    )
  }
}
